module.exports = __webpack_public_path__ + "img/27.2d92429a.jpg";